<template>
    <div class="sybg">
        <a-row style="height: 100%;">
            <a-col :span="5" style="height: 100%;padding-left: 30px;">
                <a-row class="bian">
                    <a-col :span="8">
                        <FenXi :fenxi="fenxi" />
                    </a-col>
                    <a-col :span="8">
                        <ShishiChuneng />
                    </a-col>
                    <a-col :span="8">
                        <ShishiJiedian />
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="14" style="padding:0 30px">
                <GaiKuang :info="info" />
                <DiTu />
            </a-col>
            <a-col :span="5" style="height: 100%;align-items: flex-end;padding-right: 30px;">
                <a-row class="bian">
                    <a-col :span="8">
                        <DianChi />
                    </a-col>
                    <a-col :span="8">
                        <JingJi />
                    </a-col>
                    <a-col :span="8">
                        <GaoJing :gaojing="gaojing" />
                    </a-col>
                </a-row>
            </a-col>
        </a-row>
    </div>
</template>

<script>
import http from "@/api/http";
import { ref, getCurrentInstance, defineComponent, onMounted } from "vue";
import FenXi from '../index/FenXi.vue';
import ShishiChuneng from '../index/ShishiChuneng.vue';
import ShishiJiedian from '../index/ShishiJiedian.vue';
import GaiKuang from '../index/GaiKuang.vue';
import DiTu from '../index/DiTu.vue';
import DianChi from '../index/DianChi.vue';
import JingJi from '../index/JingJi.vue';
import GaoJing from '../index/GaoJing.vue';
export default defineComponent({
    name: 'MainPage',
    components: {
        FenXi,
        ShishiChuneng,
        ShishiJiedian,
        GaiKuang,
        DianChi,
        JingJi,
        GaoJing,
        DiTu
    },
    setup() {
        const provinceId = getCurrentInstance()?.appContext.config.globalProperties.$provinceId;
        let info = ref({
            base_station_total: "",
            online_total: "",
            peak_shaving_total: "",
            peak_shaving_power_rate_total: "",
        });

        let fenxi = ref({
            charge_total: "",
            discharge_total: "",
            today_money_save: "",
            month_money_save: "",
        });

        let gaojing = ref([])

        const getData = () => {
            http.get("/base_station/province/" + provinceId).then((res) => {

                info.value.base_station_total = res.data.base_station_total;
                info.value.online_total = res.data.online_total;
                info.value.peak_shaving_total = res.data.peak_shaving_total;
                info.value.peak_shaving_power_rate_total = res.data.peak_shaving_power_rate_total;

                fenxi.value.charge_total = res.data.charge_total;
                fenxi.value.discharge_total = res.data.discharge_total;
                fenxi.value.today_money_save = res.data.today_money_save;
                fenxi.value.month_money_save = res.data.month_money_save;

                gaojing.value = res.data.warning_info

            });
        };

        onMounted(() => {
            //组件挂载时的生命周期执行的方法
            getData();
        });

        return {
            info,
            fenxi,
            gaojing,
            getData
        };
    },
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bian {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: url("@/assets/bjk.png");
    background-size: 100% 100%;
    padding-top: 50px;

}

.sybg {
    height: 100%;
    background: url(" @/assets/bg.png");
    background-size: 100% 100%;
}

.bian .ant-col-8 {
    max-width: 100%;
}
</style>
